import React, {useState, useEffect, useRef} from "react";
import Modal from "react-bootstrap/Modal";
import {Avatar, DatePicker} from "antd";
import ApiService from "../../util/ApiService";
import Swal from "sweetalert2";
import "react-datepicker/dist/react-datepicker.css";
import dayjs from "dayjs";

import AuthService from "../../util/AuthService";
import HospitalSearch from "../../hospital/HospitalSearch";
import ptBRLocale from "antd/es/date-picker/locale/pt_BR";
import {format as formatDate} from "date-fns/format";
import {format} from "date-fns";

const {RangePicker} = DatePicker;


const DutyPresenceCheckModal = ({show, handleClose, handleSubmit, duty}) => {
    const refUserSearch = useRef(null);
    const selectInputRef = useRef();

    const hospitalSearchRef = useRef(null);
    const [dutyData, setDutyData] = useState({
        duty_id: null,
        presence_registers: []
    });

    const [loading, setLoading] = useState(false); // Estado de carregamento
    const [errorMessage, setErrorMessage] = useState('');


    const formatDate = (date) => {
        console.log('formatDate recebeu:', date, 'é Date?', date instanceof Date);
        if (!date || !(date instanceof Date) || isNaN(date.getTime())) {
            return '';
        }

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const formatDateString = (date) => {
        const d = dayjs(date); // Aceita Date ou string
        return d.isValid() ? d.format('YYYY-MM-DDTHH:mm') : '';
    };


    const onSubmit = async (e) => {

        console.log(dutyData);
        setLoading(true); // Inicia o carregamento


        const formattedDuty = {
            duty_id: duty.id,
            ...(dutyData.id != null && {id: dutyData.id}),
            presence_registers: dutyData.presence_registers?.map((item) => ({
                ...item,
                checkin_at: formatDateTimeSend(item.checkin_at),
                checkout_at: formatDateTimeSend(item.checkout_at),
            }))
        };

        const apiEndpoint = `${process.env.REACT_APP_URL_API}presence/justification`;
        const method = 'post';

        try {
            await ApiService.send(method, apiEndpoint, formattedDuty, true);
            Swal.fire({
                title: 'Sucesso!',
                text: duty ? 'Plantão atualizado com sucesso!' : 'Plantão cadastrado com sucesso!',
                icon: 'success',
                confirmButtonText: 'OK'
            }).then((result) => {
                if (result.isConfirmed) {
                    handleClose(true); // Só fecha depois que o usuário clicar em OK
                }
            });
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false); // Finaliza o carregamento
        }
    };


    useEffect(() => {
        if (
            dutyData.date_time &&
            dutyData.date_time_end && dutyData.id === null
        ) {

            const start = new Date(dutyData.date_time);
            const end = new Date(dutyData.date_time_end);

            const diffMs = end.getTime() - start.getTime(); // Diferença em milissegundos
            const diffHours = diffMs / 1000 / 60 / 60; // Converter para horas

            const totalValue = parseFloat((diffHours * dutyData.hourly_rate).toFixed(2));


            setDutyData(prev => ({
                ...prev,
                value: totalValue,
            }));
        }
    }, [dutyData.department_id, dutyData.date_time_end, dutyData.hourly_rate]);


    const resetDutyData = () => {

        if (selectInputRef.current) {
            selectInputRef.current.clearValue(); // <- força o select a resetar visualmente
        }


        if (hospitalSearchRef.current) {
            hospitalSearchRef.current.clearHospital();
        }

        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }


        setErrorMessage('');
        handleClearDateRange();

        setDutyData({
            id: '',
            date_time: null,
            date_time_end: null,
            value: 0,
            hospital_id: '',
            department_id: null,
            specialties: null, // <- limpa os especialistas
            observation: '',
            self_approval: 0,
            validated_user: 1,
            id_user_accepted: null,
            scale_id: null
        });

    };

    useEffect(() => {
        if (show) {
            setErrorMessage('');

            if (duty) {
                if (duty?.presence_registers) {
                    const updatedRegisters = duty.presence_registers?.map((item) => ({
                        ...item,
                        presence_type: item.presence_type ?? 'checkin_and_checkout',
                    }));

                    setDutyData(prev => ({
                        ...prev,
                        presence_registers: updatedRegisters,
                        duty_id: duty.id,
                        id: duty.presence_registers?.[0]?.id ?? null, // cuidado se tiver mais de um registro
                    }));

                } else {
                    setDutyData(prev => ({
                        ...prev,
                        justification: "",
                        presence_registers: [],
                        duty_id: duty.id,
                        id: null,
                    }));

                }
            }

        }
    }, [show, duty]);


    const calculateDuration = (start, end) => {
        if (!start || !end) return "00:00:00";
        const s = new Date(start);
        const e = new Date(end);
        const diffMs = e - s;
        const totalSeconds = Math.floor(diffMs / 1000);
        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');
        return `${hours}:${minutes}:${seconds}`;
    };

    const formatValue = (value) => {
        const num = typeof value === "number" ? value : parseFloat(value);
        return isNaN(num) ? value : num.toLocaleString("pt-BR", {minimumFractionDigits: 2, maximumFractionDigits: 2});
    };

    const handleClearDateRange = () => {
        setDutyData(prev => ({
            ...prev,
            date_time: null,
            date_time_end: null,
        }));

    };

    const formatDateTimeSend = (date) => {
        return date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : null;
    };
    const formatDateTime = (dateTime) => {
        if (!dateTime) return "Data inválida";

        try {
            // Garante que o formato seja ISO
            const isoDate = typeof dateTime === "string"
                ? dateTime.replace(" ", "T")
                : dateTime;

            const date = new Date(isoDate);

            if (isNaN(date.getTime())) {
                return "Data inválida";
            }

            return format(date, "dd/MM/yyyy HH:mm");
        } catch (error) {
            console.error("Erro ao formatar data:", error);
            return "Erro ao formatar data";
        }
    };


    const timeToMinutes = (timeStr) => {
        if (!timeStr) return 0;
        const [h, m, s] = timeStr.split(":").map(Number);
        return h * 60 + m + (s >= 30 ? 1 : 0); // arredonda se s >= 30
    };

    const minutesToTime = (minutes) => {
        const sign = minutes < 0 ? "-" : "";
        const abs = Math.abs(minutes);
        const h = Math.floor(abs / 60);
        const m = abs % 60;
        return `${sign}${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:00`;
    };

    const calculateMinutes = (start, end) => {
        if (!start || !end) return 0;
        const s = new Date(start);
        const e = new Date(end);
        return Math.floor((e - s) / 60000); // em minutos
    };


    return (
        <>
            <Modal show={show} onHide={handleClose} centered size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>Validar Presença </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="event-details">
                            <div className="row mb-4 align-items-start">

                                {/* Coluna: Imagem do hospital */}
                                <div className="col-md-2 col-3 text-center">
                                    <img
                                        src={duty?.hospital?.images?.[0]?.file || `${process.env.REACT_APP_URL_STORAGE}src/hospital_icone.png`}
                                        alt={duty?.hospital?.name}
                                        className="img-fluid rounded"
                                        style={{maxWidth: "80px"}}
                                    />
                                </div>

                                {/* Coluna: Informações do hospital e solicitante */}
                                <div className="col-md-4 col-9">
                                    <div className="d-flex align-items-center mb-2">
                                        <Avatar
                                            src={duty?.user?.profile_image || `${process.env.REACT_APP_URL_STORAGE}src/perfil_icone.png`}
                                            size={32}
                                            className="me-2 rounded-circle object-fit-cover"
                                        />
                                        <h6 className="mb-0">{duty?.user?.name || 'Nome não disponível'}</h6>
                                    </div>
                                    <p className="hospital-name mb-1">
                                        <a
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`/admin/location-detail/${duty?.hospital?.url_page}`}
                                        >
                                            {duty?.hospital?.name || "Nome não disponível"}
                                        </a>
                                    </p>
                                    <p className="hospital-phone text-muted mb-0">
                                        Telefone: {duty?.hospital?.phone_number || "Telefone não disponível"}
                                    </p>
                                </div>

                                {/* Coluna: Informações do profissional aceito e detalhes */}
                                <div className="col-md-6 col-12 mt-3 mt-md-0">

                                    {/* Usuário aceito */}
                                    {duty?.accept_user ? (
                                        <div className="d-flex align-items-center mb-2">
                                            <Avatar
                                                src={duty?.accept_user?.profile_image || `${process.env.REACT_APP_URL_STORAGE}src/perfil_icone.png`}
                                                size={32}
                                                className="me-2 rounded-circle object-fit-cover"
                                            />
                                            <h6 className="mb-0">{duty?.accept_user?.name || 'Nome não disponível'}</h6>
                                        </div>
                                    ) : (
                                        <div className="alert alert-primary py-1 px-2 mb-2" role="alert">
                                            Nenhum Usuário Aceito
                                        </div>
                                    )}

                                    {/* Departamento */}
                                    <p className="mb-2">
                                      <span className="badge bg-dark d-inline-flex align-items-center">
                                        <i className="fa fa-hospital text-info me-2"></i>
                                          {duty?.department?.name}
                                      </span>
                                    </p>

                                    {/* Datas */}
                                    <div className="row col-12">
                                        <div className="col-6">
                                            <div className="mb-1">
                                                <i className="fa fa-calendar-check-o text-info me-2"></i>
                                                {formatDateTime(duty?.date_time)}
                                            </div>
                                            <div className=" mb-1">
                                                <i className="fa fa-calendar-check-o text-info me-2"></i>
                                                {formatDateTime(duty?.date_time_end)}
                                            </div>
                                            <div className=" mb-1">
                                                <i className="fa fa-money text-info me-2"></i>
                                                <strong>R$ {formatValue(duty?.value)}</strong>
                                            </div>

                                        </div>
                                        <div className="col-6">

                                            <div className="row">
                                                <p className="mb-1">
                                                    <i className="fa fa-clock text-info me-1"></i>
                                                    Duração: {calculateDuration(duty?.date_time, duty?.date_time_end)}
                                                </p>

                                                {/* Carga horária trabalhada */}
                                                <p className="mb-1">
                                                    <i className="fa fa-check-circle text-success me-1"></i>
                                                    Trabalhada: {duty?.total_worked_hours || "-"}
                                                </p>

                                                {/* Intervalo */}
                                                <p className="mb-1">
                                                    <i className="fa fa-coffee text-warning me-1"></i>
                                                    Intervalo: {duty?.lunch_time ? `${duty?.lunch_time} min` : "-"}
                                                </p>

                                                {/* Saldo */}
                                                <p className="mb-1">
                                                    <i className="fa fa-balance-scale text-primary me-1"></i>
                                                    Saldo: {
                                                    (() => {
                                                        const plannedMinutes = calculateMinutes(duty?.date_time, duty?.date_time_end);
                                                        const lunch = Number(duty?.lunch_time) || 0;
                                                        const worked = timeToMinutes(duty?.total_worked_hours);
                                                        const saldo = worked - (plannedMinutes - lunch);

                                                        const saldoStr = minutesToTime(saldo);
                                                        const saldoClass = saldo < 0 ? 'text-danger' : 'text-success';

                                                        return <strong className={saldoClass}>{saldoStr}</strong>;
                                                    })()
                                                }
                                                </p>
                                            </div>

                                        </div>


                                    </div>

                                    {/* Tempo de Pausa */}
                                    {duty?.lunch_time && (
                                        <div className="mt-2">
                                            <i className="fa fa-coffee text-warning me-2"></i>
                                            Tempo de Pausa: {duty.lunch_time?.slice(0, 5)}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <hr/>

                        </div>
                        {Array.isArray(dutyData?.presence_registers) && dutyData.presence_registers.map((presence, index) => (

                            <div className="row mb-3" key={index}>
                                {/* Tipo */}
                                <div className="col-md-4 form-group">
                                    <label>Tipo</label>
                                    <select
                                        className="form-control"
                                        value={presence.presence_type}
                                        onChange={(e) => {
                                            const updated = [...dutyData.presence_registers];
                                            updated[index].presence_type = e.target.value;
                                            setDutyData(prev => ({
                                                ...prev,
                                                presence_registers: updated
                                            }));
                                        }}
                                    >
                                        <option value="checkin">Check-in</option>
                                        <option value="checkout">Check-out</option>
                                        <option value="checkin_and_checkout">Check-in e check-out</option>
                                    </select>
                                </div>


                                {(!presence.presence_type || presence.presence_type === 'checkin' || presence.presence_type === 'checkin_and_checkout') && (
                                    <div className="col-md-4 form-group">
                                        <label>Data e Hora de Início</label>
                                        <DatePicker
                                            format="DD/MM/YYYY HH:mm"
                                            locale={ptBRLocale}
                                            showTime={{
                                                format: "HH:mm",
                                                defaultValue: dayjs("00:00", "HH:mm"),
                                            }}
                                            value={presence.checkin_at ? dayjs(presence.checkin_at) : null}
                                            onCalendarChange={(value) => {
                                                if (value && value.isValid()) {
                                                    const updated = [...dutyData.presence_registers];
                                                    updated[index].checkin_at = value.toDate();
                                                    setDutyData(prev => ({
                                                        ...prev,
                                                        presence_registers: updated
                                                    }));
                                                }
                                            }}
                                            getPopupContainer={() => document.body}
                                            popupStyle={{zIndex: 9999}}
                                            style={{width: "100%"}}
                                        />
                                    </div>
                                )}

                                {(!presence.presence_type || presence.presence_type === 'checkout' || presence.presence_type === 'checkin_and_checkout') && (
                                    <div className="col-md-4 form-group">
                                        <label>Data e Hora de Término</label>
                                        <DatePicker
                                            format="DD/MM/YYYY HH:mm"
                                            locale={ptBRLocale}
                                            showTime={{
                                                format: "HH:mm",
                                                defaultValue: dayjs("00:00", "HH:mm"),
                                            }}
                                            value={presence.checkout_at ? dayjs(presence.checkout_at) : null}
                                            onCalendarChange={(value) => {
                                                if (value && value.isValid()) {
                                                    const updated = [...dutyData.presence_registers];
                                                    updated[index].checkout_at = value.toDate();
                                                    setDutyData(prev => ({
                                                        ...prev,
                                                        presence_registers: updated
                                                    }));
                                                }
                                            }}
                                            getPopupContainer={() => document.body}
                                            popupStyle={{zIndex: 9999}}
                                            style={{width: "100%"}}
                                        />
                                    </div>
                                )}
                                <div className="form-group">
                                    <label>Observação</label>
                                    <textarea
                                        placeholder="Digite a observação"
                                        value={dutyData.presence_registers[index].justification || ''}
                                        onChange={(e) => {
                                            const updated = [...dutyData.presence_registers];
                                            updated[index].justification = e.target.value;
                                            setDutyData(prev => ({
                                                ...prev,
                                                presence_registers: updated
                                            }));
                                        }}
                                        className="form-control"
                                    />

                                </div>

                                {/* Botão remover */}
                                <div className="col-12 text-end mt-2">
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-danger"
                                        onClick={() => {
                                            const updated = dutyData.presence_registers.filter((_, i) => i !== index);
                                            setDutyData(prev => ({
                                                ...prev,
                                                presence_registers: updated
                                            }));
                                        }}
                                    >
                                        <i className="fa fa-trash me-1"></i>
                                        Remover Registro
                                    </button>
                                </div>

                                <hr className="my-2"/>
                            </div>
                        ))}


                        {/* Botão adicionar novo registro */}
                        <div className="text-start mb-3">
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => {
                                    setDutyData(prev => ({
                                        ...prev,
                                        presence_registers: [
                                            ...prev.presence_registers,
                                            {
                                                presence_type: 'checkin_and_checkout',
                                                checkin_at: null,
                                                checkout_at: null
                                            }
                                        ]
                                    }));
                                }}
                            >
                                <i className="fa fa-plus me-1"></i>
                                Adicionar Registro de Presença
                            </button>
                        </div>


                        {duty?.presence_registers?.logged_in_user && (
                            <div className="alert alert-info mt-2" role="alert">
                                Última alteração realizada
                                por <strong>{duty?.presence_registers?.logged_in_user?.name}</strong> no dia{" "}
                                <strong className="ml-1">{new Date(duty?.updated_at).toLocaleString("pt-BR")}</strong>

                            </div>
                        )}

                        {errorMessage && (
                            <div className="alert alert-danger mt-2" role="alert">
                                <div dangerouslySetInnerHTML={{__html: errorMessage}}/>
                            </div>
                        )}


                    </form>
                </Modal.Body>
                <Modal.Footer>
                    {!duty?.id && (
                        <button className="btn mt-2 mr-1  me-2" onClick={() => {
                            resetDutyData();             // limpa os dados
                        }}>
                            <i className="fa fa-eraser"></i> Limpar Campos
                        </button>
                    )}
                    <button type="button" className="btn mt-2 btn-secondary"

                            onClick={() => {
                                resetDutyData(); // ← limpa tudo ao fechar
                                handleClose(false);
                            }}>
                        <i className="fa fa-close"></i>{" "}Fechar
                    </button>
                    <button
                        type="button"
                        className="btn btn-info mt-2"
                        onClick={() => onSubmit()}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
            <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
            ></span>
                                Salvando...
                            </>
                        ) : dutyData?.id ? (
                            <>
                                <i className="fa fa-refresh me-2"></i> Atualizar
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus me-2"></i> Cadastrar
                            </>
                        )}
                    </button>

                </Modal.Footer>
            </Modal>


        </>
    )
        ;
};

export default DutyPresenceCheckModal;
